import { render, staticRenderFns } from "./CobrancaOcorrencia.vue?vue&type=template&id=7e1628e6&"
import script from "./CobrancaOcorrencia.vue?vue&type=script&lang=js&"
export * from "./CobrancaOcorrencia.vue?vue&type=script&lang=js&"
import style0 from "./CobrancaOcorrencia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports